<template>
  <footer class="library-footer">
    <img src="@/assets/images/logo_classe_grey.svg" alt="classe logo" class="logo-icon">
    <span class="text">
        Powered by Classe
    </span>
  </footer>
</template>

<script>
export default {
  name: 'library-footer'
}
</script>

<style scoped>
</style>
